<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<div>
   <div>Select one of the following options to create a shipment.</div>
   <br/>

   <mat-radio-group [formControl]="from">
      <mat-radio-button id="newShipmentRadioButton" [value]="'blank'">New Shipment Request</mat-radio-button>

      <mat-radio-button id="templateRadioButton" #template [value]="'template'">From a Template</mat-radio-button>
      <ng-container *ngIf="template.checked">
         <mat-form-field *ngIf="templateService.getTemplates() | async as templates; else spinner">
            <mat-label>Template Name</mat-label>
            <mat-select id="templateSelect" required [formControl]="template_id">
               <ng-container *ngFor="let template of templates; let last = last">
                  <mat-option id="templateOption" [value]="template.id" (click)="click(template)">
                     {{ template.name }}
                  </mat-option>
                  <mat-divider *ngIf="!last"></mat-divider>
              </ng-container>
            </mat-select>
         </mat-form-field>
         <mat-label class="template-desc">{{ tempDescription }}</mat-label>
      </ng-container>

      <ng-container *ngIf="hasQuote()">
         <mat-radio-button id="pastQuoteRadioButton" #pastQuote [value]="'p_quote'">From a Past Quote Request</mat-radio-button>
         <ng-container *ngIf="pastQuote.checked">
            <mat-form-field class="common-w12ex">
               <mat-select id="pastQuoteSelect" required [formControl]="q_mode">
                  <mat-option id="copyOption" value="copy">Copy</mat-option><mat-divider></mat-divider>
                  <mat-option id="continueOption" value="continue">Continue</mat-option><mat-divider></mat-divider>
                  <mat-option id="reverseOption" value="reverse">Reverse</mat-option><mat-divider></mat-divider>
               </mat-select>
            </mat-form-field>

            <mat-form-field [hideRequiredMarker]="true">
               <mat-label>Quote Request #</mat-label>
               <input id="pastQuoteInput" matInput required [formControl]="q_number" />
            </mat-form-field>
         </ng-container>
      </ng-container>

      <mat-radio-button id="pastShipmentRadioButton" #past [value]="'previous'">From a Past Shipment</mat-radio-button>
      <ng-container *ngIf="past.checked">
         <mat-form-field class="common-w12ex">
            <mat-select id="pastShipmentSelect" required [formControl]="mode">
               <mat-option id="copyOption" value="copy">Copy</mat-option><mat-divider></mat-divider>
               <mat-option id="continueOption" value="continue">Continue</mat-option><mat-divider></mat-divider>
               <mat-option id="reverseOption" value="reverse">Reverse</mat-option><mat-divider></mat-divider>
            </mat-select>
         </mat-form-field>

         <mat-form-field [hideRequiredMarker]="true">
            <mat-label>HAWB</mat-label>
            <input  id="pastShipmentInput" matInput required [formControl]="hawb" />
         </mat-form-field>
      </ng-container>

      <mat-radio-button [value]="'resume'" *ngIf="resume">Resume Shipment</mat-radio-button>
   </mat-radio-group>

   <!-- <div class="common-mt1em" *ngIf="!loading else spinner">
      <button mat-raised-button color="primary" [disabled]="(template.checked && !template_id.value) || (past.checked && !hawb.value) || (hasQuote() && from.value === 'p_quote' && !q_number.value)" (click)="next()">
         Create
      </button>
   </div> -->
</div>
